import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'

const firebaseConfig = {
  apiKey: 'AIzaSyDUeuu8-jjUtpcDeL33uc3xLM79Rj4jv9E',

  authDomain: 'challenger-reactive-fullstack.firebaseapp.com',

  projectId: 'challenger-reactive-fullstack',

  storageBucket: 'challenger-reactive-fullstack.appspot.com',

  messagingSenderId: '20726481161',

  appId: '1:20726481161:web:2ecf7641e976c04d3353d8',
}

export const app = initializeApp(firebaseConfig)
export const auth = getAuth()
